import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { catchError, throwError } from 'rxjs';
import { NavBarComponent } from 'src/app/nav-bar/nav-bar.component';
import { GroupService } from 'src/app/services/group.service';

@Component({
    selector: 'app-delete-sample-group',
    templateUrl: './delete-sample-group.component.html',
    styleUrls: ['./delete-sample-group.component.css'],
    standalone: false
})
export class DeleteSampleGroupComponent {


  groupId:number = null;
  isBulkDelete:boolean = false;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
      public deleteSampleGroupDialog: MatDialogRef<DeleteSampleGroupComponent>,
      public nav: NavBarComponent,
      private groupService: GroupService,
  ) {
  }
  ngOnInit(): void {
   if(this.data){
    this.groupId = this.data.groupId;
    this.isBulkDelete = this.data.bulkDelete;
   }
  }


  close(): void {
    this.deleteSampleGroupDialog.close({"option": "cancel"});
  }



  deleteGroupById(){
    this.nav.toggleLoading(true);

      this.groupService.deleteGroupById(this.groupId).pipe(
        catchError(error => {
          console.error(error);
          return throwError(() => error);
        })
    ).subscribe(() => {
      this.deleteSampleGroupDialog.close({"option": "delete"});
      this.nav.toggleLoading(false);
    });
  }

//DELETE BULK

  // deleteGroupById(){
  //   this.nav.toggleLoading(true);
  //   if(this.isBulkDelete = true){
  //     this.deleteSampleGroupDialog.close({"option": "delete"});
  //   }else{
  //     this.groupService.deleteGroupById(this.groupId).pipe(
  //       catchError(error => {
  //         console.error(error);
  //         return throwError(() => error);
  //       })
  //   ).subscribe(() => {
  //     this.deleteSampleGroupDialog.close({"option": "delete"});
  //     this.nav.toggleLoading(false);
  //   });
  // }
  //   }
  
}
